/**
 * IAP on-screen diagnostics — TEMPORARY developer aid.
 *
 * Renders only when the build opts in (`VITE_IAP_DIAGNOSTICS=true`) or in a
 * Vite dev server. Never prints secrets, tokens, JWS payloads or user data:
 * only feature-flag booleans, plugin registration state, requested product
 * ids and the raw error string returned by the native layer.
 */

export type IapDiagnosticsCase =
  | "not_native_ios"
  | "flag_disabled"
  | "probing"
  | "plugin_not_registered"
  | "zero_products"
  | "native_error"
  | "products_loaded";

export interface IapDiagnosticsSnapshot {
  isNativeIOS: boolean;
  flagEnabled: boolean;
  capacitorPluginAvailable: boolean;
  pluginAvailable: boolean;
  nativeProbeResponded: boolean;
  probing: boolean;
  getProductsStarted: boolean;
  getProductsResponseReceived: boolean;
  requestedProductIds: string[];
  returnedProductIds: string[];
  productCount: number;
  errorDetail: string | null;
  uiState: string | null;
  storeKitReady: boolean;
}

export function isIapDiagnosticsEnabled(_isNativeIOS = false): boolean {
  try {
    // Opt-in only: the App Store review build must never render the panel.
    // The direct Vite access guarantees the value is replaced at build time.
    return import.meta.env.DEV || import.meta.env.VITE_IAP_DIAGNOSTICS === "true";
  } catch {
    return false;
  }
}

export function classifyIapDiagnostics(s: IapDiagnosticsSnapshot): IapDiagnosticsCase {
  if (!s.isNativeIOS) return "not_native_ios";
  if (!s.flagEnabled) return "flag_disabled";
  if (s.probing) return "probing";
  if (!s.pluginAvailable) return "plugin_not_registered";
  if (s.productCount > 0) return "products_loaded";
  if (s.getProductsStarted && s.errorDetail && s.errorDetail !== "storekit_returned_zero_products") {
    return "native_error";
  }
  if (s.getProductsResponseReceived) return "zero_products";
  return "probing";
}

export const IAP_DIAGNOSTICS_CASE_LABEL: Record<IapDiagnosticsCase, string> = {
  not_native_ios: "No es iOS nativo (web/preview) — StoreKit no aplica",
  flag_disabled: "VITE_IAP_APPLE_ENABLED = false",
  probing: "Comprobando registro del plugin…",
  plugin_not_registered: "CASO 1 — Plugin NO registrado (MBLearnIap ausente en el bridge)",
  zero_products: "CASO 2 — Plugin registrado, Product.products(for:) devolvió 0",
  native_error: "CASO 3 — Error nativo de StoreKit",
  products_loaded: "CASO 4 — Productos cargados correctamente",
};
